import { render, staticRenderFns } from "./PkDataTable.vue?vue&type=template&id=7394d63f&scoped=true"
import script from "./PkDataTable.vue?vue&type=script&lang=js"
export * from "./PkDataTable.vue?vue&type=script&lang=js"
import style0 from "./PkDataTable.vue?vue&type=style&index=0&id=7394d63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7394d63f",
  null
  
)

export default component.exports